import { Outlet } from 'react-router-dom'

/** 系统设置布局：仅渲染子路由内容 */
const SettingsLayout = () => <Outlet />

export default SettingsLayout
